<template>
    <app-layout :title="`${form.name}`">
        <template #header>
          <h2 class="font-semibold text-xl text-gray-800">
            <Link class="text-blue-400 hover:text-blue-600" href="/users">Users</Link>  
            <span class="text-blue-400"> /</span>
            {{ user.name }}
          </h2>
        </template>

        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <trashed-message v-if="user.deleted_at" class="mb-6" @restore="restore"> This user has been deleted. </trashed-message>
                
                <update-user-information-form :user="$page.props.user" />

                <jet-section-border />

                <delete-user-form :user="$page.props.user" />
            </div>
        </div>
    </app-layout>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import AppLayout from '@/Layouts/AppLayout'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

import JetSectionBorder from '@/Jetstream/SectionBorder.vue'

import UpdateUserInformationForm from '@/Pages/Users/Partials/UpdateUserInformationForm.vue'
import DeleteUserForm from '@/Pages/Users/Partials/DeleteUserForm.vue'


export default {
  components: {
    AppLayout,
    FileInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    JetSectionBorder,
    UpdateUserInformationForm,
    DeleteUserForm,
  },
  props: {
    user: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        _method: 'put',
        name: this.user.name,
        email: this.user.email,
        admin: this.user.admin,
        password: '',
      }),
    }
  },
  methods: {
    update() {
      this.form.post(`/users/${this.user.id}`, {
        onSuccess: () => this.form.reset('password', 'photo'),
      })
    },
    destroy() {
      if (confirm('Are you sure you want to delete this user?')) {
        this.$inertia.delete(`/users/${this.user.id}`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this user?')) {
        this.$inertia.put(`/users/${this.user.id}/restore`)
      }
    },
  },
}
</script>
